var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-github-1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.982 0.176c-8.73 0-15.806 7.189-15.806 16.057 0 7.489 5.046 13.78 11.873 15.555-0.005-1.856-0.011-4.132-0.014-4.841-4.561 1.008-5.524-1.965-5.524-1.965-0.746-1.925-1.821-2.437-1.821-2.437-1.488-1.034 0.112-1.013 0.112-1.013 1.646 0.117 2.514 1.717 2.514 1.717 1.462 2.546 3.836 1.81 4.771 1.385 0.147-1.076 0.572-1.811 1.041-2.227-3.642-0.421-7.47-1.849-7.47-8.232 0-1.818 0.641-3.304 1.689-4.471-0.17-0.42-0.732-2.114 0.159-4.408 0 0 1.377-0.447 4.51 1.707 1.308-0.369 2.711-0.554 4.104-0.561 1.393 0.006 2.797 0.191 4.108 0.561 3.13-2.155 4.504-1.707 4.504-1.707 0.893 2.294 0.331 3.988 0.161 4.408 1.051 1.166 1.687 2.652 1.687 4.471 0 6.398-3.836 7.806-7.487 8.219 0.588 0.517 1.112 1.53 1.112 3.084 0 1.234-0.006 4.075-0.011 6.231 6.683-1.874 11.593-8.090 11.593-15.476 0-8.868-7.077-16.057-15.806-16.057z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.edd1abda561727c1b0b20a72e05869e5.svg";
export { ForwardRef as ReactComponent };